module.exports = __webpack_public_path__ + "static/img/f4f83523.svg";